import { Box, Card, CardActionArea, Icon, Typography, Container, Button } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import React, { useEffect, useState, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { getEnvVariable } from '../../../../modules/environmentalList';
import { GetData } from '../../../controls/helpers/requests';

const ExternalMain = () => {
    const history = useHistory();
    const theme = useTheme();
    const [cards, setCard] = useState([]);
    const [userName, setUserName] = useState('');
    const [isExternalUser, setIsExternalUser] = useState(false);
    const [cardThemeColor, setCardThemeColor] = useState('#1976d2');
    const [isLoading, setIsLoading] = useState(true);
    const [retryCount, setRetryCount] = useState(0);
    const submodules = localStorage.getItem('submodule')
            ? JSON.parse(localStorage.getItem('submodule'))
            : [];

    useEffect(() => {
        try {
            const profile = localStorage.getItem('profile');
            if (profile) {
                const parsedProfile = JSON.parse(profile);
                const name = parsedProfile.name || parsedProfile.Name || parsedProfile.firstName || parsedProfile.FirstName || 'User';
                setUserName(name);

                const accessPortal = getEnvVariable('AccessPortal');
                setIsExternalUser(accessPortal === 'E');
            }
        } catch (error) {
            setUserName('User');
            setIsExternalUser(getEnvVariable('AccessPortal') === 'E');
        }
    }, []);

    // Function to load cards data
    const loadCardsData = useCallback(() => {
        const submodules = localStorage.getItem('submodule')
            ? JSON.parse(localStorage.getItem('submodule'))
            : [];

        console.log('Loading cards data:', { submodules: submodules.length, retryCount });

        // If no data available yet, retry after a short delay
        if (!submodules.length && retryCount < 10) {
            setTimeout(() => {
                setRetryCount(prev => prev + 1);
            }, 500);
            return;
        }

        let merged = [];
        if (submodules.length) {
            // Group submodules by order - same logic as menutabs.js
            const grouped = submodules.map(sub => {
                return {
                    ...sub,
                    DisplayName: getEnvVariable("AccessPortal") === 'E' && getEnvVariable("ModuleKey") !== 'APPS' && getEnvVariable("Port") !== '8553'&& submodules.length ===1 ? "My Segments" : sub.displayName || sub.title,
                    Color: sub.color || '',
                    MaterialIcon: sub.materialicon || '',
                    // Keep additional properties from the original logic
                    color: sub.color || '#1976d2',
                    materialicon: sub.materialicon || '',
                    image: sub.image || '',
                    description: sub.description || '',
                    displayOrder: sub.order || sub.Order || 999,
                    // Add SubModuleKey for navigation
                    SubModuleKey: sub.key || sub.SubModuleKey
                };
            });

            // Flatten the grouped array and filter out empty arrays
            merged = grouped.flat().filter(Boolean);
        }
        
        setCard(merged);
        setIsLoading(false);

        // Set theme color for external users (use first card's color)
        if (merged.length > 0 && getEnvVariable('AccessPortal') === 'E') {
            setCardThemeColor(merged[0].color || '#1976d2');
        }

        console.log('Cards loaded successfully:', merged.length);
    }, [retryCount]);

    // Load cards data on mount and when retryCount changes
    useEffect(() => {
        loadCardsData();
    }, [loadCardsData]);

    // Check if brown/rust theme should be applied
    const useCustomTheme = getEnvVariable("ModuleKey") === 'APPS' && getEnvVariable("Port") === '8553';

    // const handleDashboardNavigate = (card) => {
    //     console.log('handleDashboardNavigate called:', { card, cardsLength: cards.length });
    //     const targetCard = card || (cards.length > 0 ? cards[0] : null);
    //     if (targetCard?.DisplayName) {
    //         if (targetCard?.DisplayName.includes('Provider')) {
    //             let link = '/userdashboardflows/view/' + getEnvVariable('DashboardFlowsIdAAH')['Provider'];
    //             return history.push(link);
    //         } else if (targetCard?.DisplayName.includes('Volunteer') || targetCard?.DisplayName.includes('Adoptions')) {
    //             let link = '/userdashboardflows/view/' + getEnvVariable('DashboardFlowsIdAAH')['Volunteer'];
    //             return history.push(link);
    //         } else if (targetCard?.DisplayName.includes('Sponsor')) {
    //             let link = '/userdashboardflows/view/' + getEnvVariable('DashboardFlowsIdAAH')['Sponsor'];
    //             return history.push(link);
    //         }
    //     }
    // };

    const handleInvoiceNavigate = (card) => {
        console.log('handleInvoiceNavigate called:', { card, cardsLength: cards.length });
        
        // If no card provided, try to use first available card
        const targetCard = card || (cards.length > 0 ? cards[0] : null);
        
        if (targetCard?.DisplayName) {
            let link = '/userdashboardflows/view/' + getEnvVariable('DashboardFlowsIdAAH')['Invoice'];
            console.log('Navigating to Invoice:', link);
            return history.push(link);
        } else {
            console.warn('No valid card found for invoice navigation:', { targetCard, cards });
        }
    };

    const handleModuleNavigate = (card, add = false) => {
        console.log('handleModuleNavigate called:', { card, add, cardsLength: cards.length });
        
        // If no card provided, try to use first available card
        const targetCard = card || (cards.length > 0 ? cards[0] : null);
        
        if (targetCard?.SubModuleKey || targetCard?.key) {
            const subModuleKey = targetCard.SubModuleKey || targetCard.key;
            const url = getEnvVariable('AdminConfig') + `/api/ProcessCategory/Published/${subModuleKey}`;
            
            GetData(url)
                .then((res) => {
                    if (res && res.data && Array.isArray(res.data)) {
                        if (res.data.length > 1) {
                            // Navigate to list page if more than one process flow
                            const link = `/userprocessflowlist/${subModuleKey}`;
                            console.log('Navigating to list page:', link);
                            return history.push(link);
                        } else if (res.data.length === 1) {
                            // Navigate directly to the single process flow
                            const processFlow = res.data[0];
                            const flowId = processFlow.FlowId;
                            const version = processFlow?.Version || '1.0';
                            let link = processFlow.link || '/userprocessflows';
                            if (!link.endsWith('/')) {
                                link = `${link}/`;
                            }
                            link += flowId;
                            if (version) {
                                link += `/${version}`;
                            }
                            if (add) {
                                link += '/0';
                            }
                            console.log('Navigating to single process flow:', link);
                            return history.push(link);
                        } else {
                            // No process flows found, navigate to default
                            const link = `/userprocessflowlist/${subModuleKey}`;
                            console.log('No process flows found, navigating to default:', link);
                            return history.push(link);
                        }
                    } else {
                        // Fallback navigation if API fails
                        const link = `/userprocessflowlist/${subModuleKey}`;
                        console.log('API response invalid, fallback navigation:', link);
                        return history.push(link);
                    }
                })
                .catch((error) => {
                    console.error("Error fetching process flows:", error);
                    // Fallback navigation on error
                    const link = `/userprocessflowlist/${subModuleKey}`;
                    console.log('API error, fallback navigation:', link);
                    return history.push(link);
                });
            return;
        }

        console.warn('No valid SubModuleKey found for navigation:', { targetCard, cards });
    };

    if (isExternalUser && submodules.length ===1) {
        // EXTERNAL USER - Add Segment Only
        return (
            <div style={{ height: 'inherit' }}>
                <Box style={{
                   // minHeight: '100vh',
                    background: '#f8fafc',
                    position: 'relative',
                    overflow: 'hidden',
                    display: 'flex',
                    alignItems: 'center',
                    paddingTop: '2rem',
                    paddingBottom: '3rem'
                }}>
                    <Container maxWidth={false} style={{ maxWidth: '1400px', margin: '0 auto', padding: '0 1rem' }}>
                        {/* Hero Section - Same as Internal */}
                        <Box style={{
                            textAlign: 'center',
                            marginBottom: 48,
                            padding: '20px 40px',
                            background: '#ffffff',
                            borderRadius: 16,
                            border: '1px solid #e2e8f0',
                            boxShadow: '0 1px 3px rgba(0,0,0,0.08)'
                        }}>
                            <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.75rem', marginBottom: 16 }}>
                                <Typography variant="h3" style={{
                                    fontWeight: 800,
                                    color: '#0f172a',
                                    fontSize: '2.5rem'
                                }}>
                                    Welcome, {userName}!
                                </Typography>
                                <span
                                    style={{
                                        fontSize: '2rem',
                                        display: 'inline-block',
                                        animation: 'wave 2s ease-in-out infinite',
                                        transformOrigin: '70% 70%'
                                    }}
                                >
                                    👋
                                </span>
                            </Box>
                        </Box>

                        {/* Loading State */}
                        {isLoading && (
                            <Box style={{
                                textAlign: 'center',
                                marginBottom: 32,
                                padding: '24px',
                                background: '#ffffff',
                                borderRadius: 16,
                                border: '1px solid #e2e8f0',
                                boxShadow: '0 1px 3px rgba(0,0,0,0.08)'
                            }}>
                                <Typography variant="h6" style={{
                                    color: '#64748b',
                                    fontWeight: 600,
                                    fontSize: '1.1rem'
                                }}>
                                    Loading your dashboard...
                                </Typography>
                            </Box>
                        )}

                        {/* User Role Tag - Only for External Users */}
                        {!isLoading && cards.length > 0 && (
                            <Box style={{
                                textAlign: 'center',
                                marginBottom: 32,
                                padding: '16px 24px',
                                background: '#ffffff',
                                borderRadius: 16,
                                border: '1px solid #e2e8f0',
                                boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                                maxWidth: '600px',
                                margin: '0 auto 32px'
                            }}>
                                {cards[0]?.DisplayName?.includes('Sponsor') && (
                                    <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px' }}>
                                        <Icon style={{ 
                                            color: '#10b981', 
                                            fontSize: '1.8rem'
                                        }}>
                                            stars
                                        </Icon>
                                        <Typography variant="h6" style={{
                                            color: '#0f172a',
                                            fontWeight: 700,
                                            fontSize: '1.2rem'
                                        }}>
                                            Thank you for sponsoring! We're so happy to have your support 🌟
                                        </Typography>
                                    </Box>
                                )}
                                {(cards[0]?.DisplayName?.includes('Volunteer') || cards[0]?.DisplayName?.includes('Adoptions')) && (
                                    <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px' }}>
                                        <Icon style={{ 
                                            color: '#1976d2', 
                                            fontSize: '1.8rem'
                                        }}>
                                            favorite
                                        </Icon>
                                        <Typography variant="h6" style={{
                                            color: '#0f172a',
                                            fontWeight: 700,
                                            fontSize: '1.2rem'
                                        }}>
                                            Thank you for volunteering! Your dedication makes us proud 💙
                                        </Typography>
                                    </Box>
                                )}
                                {cards[0]?.DisplayName?.includes('Provider') && (
                                    <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px' }}>
                                        <Icon style={{ 
                                            color: '#9c27b0', 
                                            fontSize: '1.8rem'
                                        }}>
                                            handyman
                                        </Icon>
                                        <Typography variant="h6" style={{
                                            color: '#0f172a',
                                            fontWeight: 700,
                                            fontSize: '1.2rem'
                                        }}>
                                            Thank you for your excellent service! We're grateful for your expertise 🔧
                                        </Typography>
                                    </Box>
                                )}
                            </Box>
                        )}

                        {!isLoading && (
                            <Box style={{ textAlign: 'center' }}>
                                {/* Action Cards for External Users */}
                            <Box style={{
                                display: 'flex',
                                gap: '32px',
                                justifyContent: 'center',
                                flexWrap: 'wrap'
                            }}>
                                {/* Add Segment Card */}
                                <Card elevation={0} style={{
                                    borderRadius: 16,
                                    minHeight: 180,
                                    minWidth: 280,
                                    maxWidth: 320,
                                    cursor: 'pointer',
                                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                    background: '#ffffff',
                                    border: '1px solid #e2e8f0',
                                    boxShadow: '0 1px 3px rgba(0,0,0,0.08)'
                                }}
                                    onMouseEnter={e => {
                                        e.currentTarget.style.transform = 'translateY(-4px)';
                                        e.currentTarget.style.boxShadow = '0 12px 32px rgba(0,0,0,0.12)';
                                        e.currentTarget.style.borderColor = cardThemeColor;
                                    }}
                                    onMouseLeave={e => {
                                        e.currentTarget.style.transform = 'translateY(0)';
                                        e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.08)';
                                        e.currentTarget.style.borderColor = '#e2e8f0';
                                    }}
                                >
                                    <CardActionArea style={{
                                        padding: '40px 24px',
                                        height: '100%',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }} onClick={() => handleModuleNavigate(null, true)}>
                                        <Box style={{
                                            width: 56,
                                            height: 56,
                                            borderRadius: 14,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            marginBottom: 16,
                                            background: `linear-gradient(135deg, ${cardThemeColor}, ${cardThemeColor}cc)`
                                        }}>
                                            <Icon style={{
                                                fontSize: 32,
                                                color: '#ffffff'
                                            }}>add_location</Icon>
                                        </Box>
                                        <Typography variant="h5" style={{
                                            fontWeight: 700,
                                            color: '#0f172a',
                                            textAlign: 'center',
                                            marginBottom: 8,
                                            fontSize: '1.4rem'
                                        }}>Adopt A Segment</Typography>
                                   
                                    </CardActionArea>
                                </Card>

                                {/* Dashboard Card */}
                                {/* <Card elevation={0} style={{
                                    borderRadius: 20,
                                    minHeight: 180,
                                    minWidth: 280,
                                    maxWidth: 320,
                                    cursor: 'pointer',
                                    transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                                    background: 'linear-gradient(135deg, #1976d2 0%, #1565c0 100%)',
                                    border: '1px solid rgba(255,255,255,0.2)',
                                    boxShadow: '0 16px 48px rgba(25,118,210,0.3)',
                                    animation: 'float 6s ease-in-out infinite',
                                    animationDelay: '1s'
                                }}
                                    onMouseEnter={e => {
                                        e.currentTarget.style.transform = 'translateY(-8px) scale(1.03)';
                                        e.currentTarget.style.boxShadow = '0 24px 64px rgba(25,118,210,0.4)';
                                    }}
                                    onMouseLeave={e => {
                                        e.currentTarget.style.transform = 'translateY(0) scale(1)';
                                        e.currentTarget.style.boxShadow = '0 16px 48px rgba(25,118,210,0.3)';
                                    }}
                                >
                                    <CardActionArea style={{
                                        padding: '40px 24px',
                                        height: '100%',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }} onClick={() => handleDashboardNavigate(null)}>
                                        <Icon style={{
                                            fontSize: 56,
                                            color: 'white',
                                            marginBottom: 16,
                                            filter: 'drop-shadow(0 4px 8px rgba(0,0,0,0.3))',
                                            animation: 'pulse 3s ease-in-out infinite',
                                            animationDelay: '0.5s'
                                        }}>dashboard</Icon>
                                        <Typography variant="h5" style={{
                                            fontWeight: 700,
                                            color: 'white',
                                            textAlign: 'center',
                                            marginBottom: 8,
                                            textShadow: '0 2px 4px rgba(0,0,0,0.3)',
                                            fontSize: '1.4rem'
                                        }}>Dashboard</Typography>
                                   
                                    </CardActionArea>
                                </Card> */}

                                {/* Invoices Card - Only show for Sponsors */}
                                {/* {cards.length > 0 && cards[0]?.DisplayName?.includes('Sponsor') && (
                                    <Card elevation={0} style={{
                                        borderRadius: 20,
                                        minHeight: 180,
                                        minWidth: 280,
                                        maxWidth: 320,
                                        cursor: 'pointer',
                                        transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                                        background: 'linear-gradient(135deg, #9c27b0 0%, #7b1fa2 100%)',
                                        border: '1px solid rgba(255,255,255,0.2)',
                                        boxShadow: '0 16px 48px rgba(156,39,176,0.3)',
                                        animation: 'float 6s ease-in-out infinite',
                                        animationDelay: '2s'
                                    }}
                                        onMouseEnter={e => {
                                            e.currentTarget.style.transform = 'translateY(-8px) scale(1.03)';
                                            e.currentTarget.style.boxShadow = '0 24px 64px rgba(156,39,176,0.4)';
                                        }}
                                        onMouseLeave={e => {
                                            e.currentTarget.style.transform = 'translateY(0) scale(1)';
                                            e.currentTarget.style.boxShadow = '0 16px 48px rgba(156,39,176,0.3)';
                                        }}
                                    >
                                        <CardActionArea style={{
                                            padding: '40px 24px',
                                            height: '100%',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }} onClick={() => handleInvoiceNavigate(null)}>
                                            <Icon style={{
                                                fontSize: 56,
                                                color: 'white',
                                                marginBottom: 16,
                                                filter: 'drop-shadow(0 4px 8px rgba(0,0,0,0.3))',
                                                animation: 'pulse 3s ease-in-out infinite',
                                                animationDelay: '1s'
                                            }}>receipt</Icon>
                                            <Typography variant="h5" style={{
                                                fontWeight: 700,
                                                color: 'white',
                                                textAlign: 'center',
                                                marginBottom: 8,
                                                textShadow: '0 2px 4px rgba(0,0,0,0.3)',
                                                fontSize: '1.4rem'
                                            }}>Invoices</Typography>
                                   
                                        </CardActionArea>
                                    </Card>
                                )} */}
                            </Box>
                            </Box>
                        )}
                    </Container>

                    <style>
                        {`
                            @keyframes wave {
                                0%, 100% { transform: rotate(0deg); }
                                10%, 30%, 50%, 70%, 90% { transform: rotate(14deg); }
                                20%, 40%, 60%, 80% { transform: rotate(-8deg); }
                            }
                            
                            @keyframes gradientShift {
                                0%, 100% { background-position: 0% 50%; }
                                50% { background-position: 100% 50%; }
                            }
                            
                            @keyframes float {
                                0%, 100% { transform: translateY(0px); }
                                50% { transform: translateY(-10px); }
                            }
                            
                            @keyframes starWave {
                                0%, 100% { transform: translateY(0px) scale(1); }
                                25% { transform: translateY(-3px) scale(1.1); }
                                50% { transform: translateY(-6px) scale(1.05); }
                                75% { transform: translateY(-3px) scale(1.1); }
                            }
                            
                            @keyframes heartWave {
                                0%, 100% { transform: translateY(0px) scale(1); }
                                30% { transform: translateY(-4px) scale(1.15); }
                                60% { transform: translateY(-2px) scale(1.08); }
                            }
                            
                            @keyframes toolWave {
                                0%, 100% { transform: translateY(0px) rotate(0deg); }
                                33% { transform: translateY(-5px) rotate(-5deg); }
                                66% { transform: translateY(-3px) rotate(5deg); }
                            }
                        `}
                    </style>
                </Box>
            </div>
        );
    }

    // INTERNAL USER - Fixed 3-Column Grid Layout
    // CHANGES MADE:
    // - Fixed 3-column grid (3 cards per row)
    // - All 7 cards visible without scrollbar (3+3+1 layout)
    // - Ultra compact with reduced card height
    // - Banner and cards in one unified box
    // - Minimal spacing between banner and cards
    return (
        <div style={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
            {/* Main Container */}
            <Box style={{
                    width: '100%',
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'flex-start',
                    background: `
                        linear-gradient(rgba(232,241,255,0.15), rgba(214,231,255,0.15)),
                        url('./images/woodcounty/LandingBG.png')
                    `,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    position: 'relative',
                    overflow: 'hidden',
                    padding: '1rem 0'
                }}>
                <Container maxWidth={false} style={{ maxWidth: '1300px', margin: '0 auto', padding: '0 1.5rem' }}>
                    {/* Welcome Banner */}
                    <Box style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        marginBottom: 14,
                        padding: '14px 20px 14px 24px',
                        background: '#ffffff',
                        borderRadius: 10,
                        border: '1px solid #e2e8f0',
                        borderLeft: `4px solid ${theme.palette.primary.main}`,
                        animation: 'fadeSlideRight 0.5s ease-out',
                        position: 'relative',
                        overflow: 'hidden'
                    }}>
                        {/* Shimmer accent */}
                        <Box style={{
                            position: 'absolute',
                            top: 0,
                            left: '-100%',
                            width: '100%',
                            height: '100%',
                            background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.6), transparent)',
                            animation: 'shimmer 3s ease-in-out 1s 1'
                        }} />
                        {/* Left side - greeting */}
                        <Box style={{ display: 'flex', flexDirection: 'column', zIndex: 1 }}>
                            <Typography style={{
                                fontWeight: 600,
                                color: '#0f172a',
                                fontSize: '0.95rem',
                                lineHeight: 1.3
                            }}>
                                {isExternalUser ? `Welcome, ${userName}` : `Welcome back, ${userName}`}
                            </Typography>
                            <Typography style={{
                                fontWeight: 400,
                                color: '#94a3b8',
                                fontSize: '0.72rem',
                                lineHeight: 1.3
                            }}>
                                {new Date().toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' })}
                            </Typography>
                        </Box>
                        {/* Right side - module count */}
                        <Box style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '6px',
                            padding: '5px 12px',
                            background: '#f1f5f9',
                            borderRadius: 6,
                            zIndex: 1
                        }}>
                            <Icon style={{ fontSize: '0.9rem', color: '#64748b' }}>apps</Icon>
                            <Typography style={{
                                fontSize: '0.72rem',
                                fontWeight: 600,
                                color: '#475569'
                            }}>
                                {cards.length} Module{cards.length !== 1 ? 's' : ''}
                            </Typography>
                        </Box>
                    </Box>

                    {/* Fixed 3-Column Grid - All 7 cards visible (3+3+1) */}
                    {/* No scrollbar needed - ultra compact design */}
                    {cards && cards.length > 0 && (
                        <Box style={{
                            display: 'flex',
                            justifyContent: 'center'
                        }}>
                            {/* 4-column grid layout */}
                            <Box style={{
                                display: 'grid',
                                gridTemplateColumns: 'repeat(4, 1fr)',
                                gap: '12px',
                                maxWidth: '1200px',
                                width: '100%'
                            }}>
                                {cards.sort((a, b) => {
                                    const orderA = a.displayOrder || a.Order || 999;
                                    const orderB = b.displayOrder || b.Order || 999;
                                    return orderA - orderB;
                                }).map((card, index) => (
                                    <Card key={index} elevation={0} style={{
                                        borderRadius: 12,
                                        display: 'flex',
                                        flexDirection: 'column',
                                        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                        background: '#ffffff',
                                        border: '1px solid #e2e8f0',
                                        boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                                        opacity: 0,
                                        animation: `fadeScaleIn 0.4s ease-out forwards`,
                                        animationDelay: `${0.15 + index * 0.08}s`
                                    }}
                                        onMouseEnter={e => {
                                            e.currentTarget.style.transform = 'translateY(-4px)';
                                            e.currentTarget.style.boxShadow = '0 12px 32px rgba(0,0,0,0.12)';
                                            e.currentTarget.style.borderColor = card.color || theme.palette.primary.main;
                                        }}
                                        onMouseLeave={e => {
                                            e.currentTarget.style.transform = 'translateY(0)';
                                            e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.08)';
                                            e.currentTarget.style.borderColor = '#e2e8f0';
                                        }}
                                    >
                                        {/* Card Content */}
                                        <Box style={{
                                            padding: '1.25rem',
                                            flex: 1,
                                            display: 'flex',
                                            flexDirection: 'column'
                                        }}>
                                            {/* Icon and DisplayName - Horizontal */}
                                            <Box style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '10px',
                                                marginBottom: '0.6rem'
                                            }}>
                                                {/* Icon Container */}
                                                <Box style={{
                                                    width: 40,
                                                    height: 40,
                                                    borderRadius: 10,
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    background: `linear-gradient(135deg, ${card.color || theme.palette.primary.main}, ${card.color ? card.color + 'cc' : theme.palette.primary.light})`,
                                                    flexShrink: 0
                                                }}>
                                                    {card.image ? (
                                                        <img src={card.image} alt={card.DisplayName || card.title}
                                                            style={{ width: 22, height: 22, objectFit: 'cover', borderRadius: 4 }} />
                                                    ) : (
                                                        <Icon style={{ fontSize: '1.2rem', color: '#ffffff' }}>
                                                            {card.materialicon}
                                                        </Icon>
                                                    )}
                                                </Box>
                                                {/* Title */}
                                                <Typography style={{
                                                    fontWeight: 700,
                                                    color: '#0f172a',
                                                    fontSize: '0.95rem',
                                                    lineHeight: 1.3,
                                                    flex: 1
                                                }}>
                                                    {card.DisplayName || card.title}
                                                </Typography>
                                            </Box>
                                            {/* Description */}
                                            {card.description && (
                                                <Typography variant="body2" style={{
                                                    color: '#64748b',
                                                    fontSize: '0.8rem',
                                                    lineHeight: 1.5,
                                                    flex: 1
                                                }}>
                                                    {card.description.length > 4000 ? card.description.substring(0, 4000) + '...' : card.description}
                                                </Typography>
                                            )}
                                        </Box>

                                        {/* Action Buttons */}
                                        <Box style={{
                                            padding: '0 1.25rem 1rem',
                                            display: 'flex',
                                            gap: '8px',
                                            marginTop: 'auto'
                                        }}>
                                            <Button
                                                variant="contained"
                                                size="small"
                                                style={{
                                                    background: card.color || theme.palette.primary.main,
                                                    color: '#ffffff',
                                                    borderRadius: '6px',
                                                    fontSize: '0.78rem',
                                                    fontWeight: 600,
                                                    padding: '4px 12px',
                                                    border: 'none',
                                                    boxShadow: 'none',
                                                    textTransform: 'none',
                                                    flex: 1,
                                                    transition: 'all 0.2s ease'
                                                }}
                                                onClick={() => handleModuleNavigate(card, false)}
                                            >
                                                View
                                            </Button>
                                            <Button
                                                variant="outlined"
                                                size="small"
                                                style={{
                                                    color: card.color || theme.palette.primary.main,
                                                    borderColor: card.color || theme.palette.primary.main,
                                                    borderRadius: '6px',
                                                    fontSize: '0.78rem',
                                                    fontWeight: 600,
                                                    padding: '4px 12px',
                                                    boxShadow: 'none',
                                                    textTransform: 'none',
                                                    background: 'transparent',
                                                    flex: 1,
                                                    transition: 'all 0.2s ease'
                                                }}
                                                onClick={() => handleModuleNavigate(card, true)}
                                            >
                                                Apply
                                            </Button>
                                            {card?.DisplayName?.includes('Sponsor') && (
                                                <Button
                                                    variant="outlined"
                                                    size="small"
                                                    style={{
                                                        color: '#64748b',
                                                        borderColor: '#e2e8f0',
                                                        borderRadius: '6px',
                                                        fontSize: '0.78rem',
                                                        fontWeight: 600,
                                                        padding: '4px 12px',
                                                        boxShadow: 'none',
                                                        textTransform: 'none',
                                                        background: 'transparent',
                                                        flex: 1
                                                    }}
                                                    onClick={() => handleInvoiceNavigate(card)}
                                                >
                                                    Invoices
                                                </Button>
                                            )}
                                </Box>
                            </Card>
                                ))}
                            </Box>
                    </Box>
                )}
                </Container>

                {/* CSS Animations */}
                <style>
                    {`
                        /* Welcome banner slide in from left */
                        @keyframes fadeSlideRight {
                            from {
                                opacity: 0;
                                transform: translateX(-20px);
                            }
                            to {
                                opacity: 1;
                                transform: translateX(0);
                            }
                        }

                        /* One-time shimmer across welcome banner */
                        @keyframes shimmer {
                            0% { left: -100%; }
                            100% { left: 100%; }
                        }

                        /* Cards fade + scale in with stagger */
                        @keyframes fadeScaleIn {
                            from {
                                opacity: 0;
                                transform: translateY(16px) scale(0.97);
                            }
                            to {
                                opacity: 1;
                                transform: translateY(0) scale(1);
                            }
                        }

                        /* Animation for waving hand emoji */
                        @keyframes wave {
                            0%, 100% { transform: rotate(0deg); }
                            10%, 30%, 50%, 70%, 90% { transform: rotate(14deg); }
                            20%, 40%, 60%, 80% { transform: rotate(-8deg); }
                        }
                        
                        /* Animation for gradient text */
                        @keyframes gradientShift {
                            0%, 100% { background-position: 0% 50%; }
                            50% { background-position: 100% 50%; }
                        }
                        
                        /* Animation for floating cards - ultra compact */
                        @keyframes float {
                            0%, 100% { transform: translateY(0px); }
                            50% { transform: translateY(-4px); }
                        }
                        
                        /* Animation for card entrance - ultra compact */
                        @keyframes slideInUp {
                            from {
                                opacity: 0;
                                transform: translateY(10px);
                            }
                            to {
                                opacity: 1;
                                transform: translateY(0);
                            }
                        }

                        ${!useCustomTheme ? `
                        /* Custom Scrollbar for horizontal scroll - Non-APPS modules */
                        *::-webkit-scrollbar {
                            height: 8px;
                        }
                        
                        *::-webkit-scrollbar-track {
                            background: rgba(255,255,255,0.1);
                            border-radius: 4px;
                        }
                        
                        *::-webkit-scrollbar-thumb {
                            background: linear-gradient(135deg, #1976d2, #1565c0);
                            border-radius: 4px;
                        }
                        
                        *::-webkit-scrollbar-thumb:hover {
                            background: linear-gradient(135deg, #1565c0, #0d47a1);
                        }
                        ` : ''}

                        /* Fixed 3-Column Grid - All 7 cards visible on all screens */
                        /* No scrollbar needed - ultra compact design */
                        @media (max-width: 1024px) {
                            /* Tablets: maintain 3 columns with slightly reduced size */
                        }
                        
                        @media (max-width: 768px) {
                            /* Small tablets/phones: may adjust to 2 columns if needed */
                        }
                        
                        @media (max-width: 480px) {
                            /* Small phones: cards scale down proportionally */
                        }
                    `}
                </style>
            </Box>
            {/* End of Cards Container */}
        </div>
    );
};

export default ExternalMain;